var _g, _path, _g2, _g3, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 45,
    viewBox: "0 0 39 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_4674_6158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4947 33.5448L16.8626 21.1984H16.9246L20.2718 33.5448H22.152L26.3876 18.7292H24.4867L21.2429 31.1586H21.1602L17.813 18.7292H15.9742L12.6063 31.1586H12.5236L9.27977 18.7292H7.37891L11.6145 33.5448H13.4947Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0039 11.1816L23.8223 -9.77525e-07C23.8223 6.17541 28.8285 11.1816 35.0039 11.1816Z",
    fill: "#B5C8FC"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_4674_6158)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8075 3.05176e-05H0.769531V44.7187H36.9917V3.05176e-05H36.9872V11.1797L25.8075 3.05176e-05Z",
    fill: "#6F6FF1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_4674_6158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75906 32.4065L12.8338 26.4175C12.8859 26.3408 12.9543 26.2764 13.0341 26.229C13.1139 26.1816 13.2032 26.1523 13.2955 26.1432C13.3879 26.1342 13.4811 26.1455 13.5686 26.1764C13.6562 26.2073 13.7358 26.2571 13.8019 26.3222L16.4948 28.9606L22.4033 19.6997C22.4618 19.6078 22.543 19.5325 22.6391 19.4812C22.7352 19.4298 22.8429 19.4041 22.9518 19.4066C23.0607 19.409 23.1672 19.4395 23.2608 19.4951C23.3545 19.5507 23.4323 19.6296 23.4866 19.724L30.8277 32.4465C30.8835 32.5428 30.9128 32.6521 30.9129 32.7634C30.913 32.8747 30.8837 32.984 30.828 33.0804C30.7724 33.1768 30.6923 33.2568 30.5959 33.3124C30.4995 33.368 30.3901 33.3971 30.2788 33.397H9.2831C9.16776 33.3973 9.05453 33.366 8.95565 33.3066C8.85677 33.2472 8.77599 33.1619 8.72202 33.06C8.66806 32.958 8.64296 32.8433 8.64944 32.7281C8.65591 32.613 8.69372 32.5017 8.75878 32.4065H8.75906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97932 18.8458C9.97932 19.693 10.3159 20.5055 10.9149 21.1046C11.514 21.7036 12.3264 22.0401 13.1736 22.0401C14.0208 22.0401 14.8333 21.7036 15.4323 21.1046C16.0314 20.5055 16.3679 19.693 16.3679 18.8458C16.3679 17.9986 16.0314 17.1862 15.4323 16.5871C14.8333 15.9881 14.0208 15.6515 13.1736 15.6515C12.3264 15.6515 11.514 15.9881 10.9149 16.5871C10.3159 17.1862 9.97932 17.9986 9.97932 18.8458Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 11.1797L25.8203 1.42814e-05C25.8203 6.17437 30.8256 11.1797 37 11.1797Z",
    fill: "#B5C8FC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_4674_6158",
    x: 6.37891,
    y: 17.7292,
    width: 28.0078,
    height: 25.8156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4674_6158"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4674_6158",
    result: "effect2_dropShadow_4674_6158"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4674_6158",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_4674_6158",
    x: 0.769531,
    y: -0.999969,
    width: 36.2227,
    height: 46.7187,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4674_6158"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_4674_6158",
    result: "effect2_innerShadow_4674_6158"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_4674_6158",
    x: 7.64844,
    y: 14.6515,
    width: 31.2656,
    height: 28.7455,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4674_6158"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4674_6158",
    result: "effect2_dropShadow_4674_6158"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4674_6158",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.fe71e9faff695ca13e02dfab7abb68f2.svg";
export { ForwardRef as ReactComponent };